import confetti from 'canvas-confetti';

export function rqAnimate(ref, keyframes, options) {
  if (!ref || !ref.current) return;
  return ref.current.animate(keyframes, { easing: 'ease-out', fill: 'forwards', ...options });
}

export function rqShake(ref) {
  return rqAnimate(ref, [{transform:'translateX(0)'},{transform:'translateX(-8px)'},{transform:'translateX(8px)'},{transform:'translateX(-6px)'},{transform:'translateX(6px)'},{transform:'translateX(0)'}], {duration:400});
}

export function rqBounceIn(ref) {
  return rqAnimate(ref, [{transform:'scale(1)'},{transform:'scale(1.15)'},{transform:'scale(0.95)'},{transform:'scale(1.05)'},{transform:'scale(1)'}], {duration:500});
}

export function rqGlowCorrect(ref) {
  return rqAnimate(ref, [{boxShadow:'0 0 0px rgba(74,222,128,0)',borderColor:'rgba(255,255,255,0.2)'},{boxShadow:'0 0 25px rgba(74,222,128,0.7)',borderColor:'#4ADE80'},{boxShadow:'0 0 10px rgba(74,222,128,0.3)',borderColor:'#4ADE80'}], {duration:600});
}

export function rqFlashWrong(ref) {
  return rqAnimate(ref, [{background:'inherit'},{background:'rgba(255,138,107,0.3)',borderColor:'#FF8A6B'},{background:'inherit',borderColor:'rgba(255,255,255,0.2)'}], {duration:500});
}

export function rqConfettiBurst(options = {}) {
  confetti({
    particleCount: options.count || 40,
    spread: options.spread || 70,
    origin: { y: options.y || 0.6 },
    colors: options.colors || ['#FF6B35', '#7B2FBE', '#4ADE80', '#FFD166', '#00D4AA'],
    ...options
  });
}

export function rqSpawnParticles(container, count, color) {
  if (!container) return;
  const n = count || 12;
  const rect = container.getBoundingClientRect();
  for (let i = 0; i < n; i++) {
    const p = document.createElement('div');
    const angle = (Math.PI * 2 * i) / n;
    const velocity = 60 + Math.random() * 40;
    const size = 4 + Math.random() * 6;
    Object.assign(p.style, {
      position: 'fixed',
      left: rect.left + rect.width/2 + 'px',
      top: rect.top + rect.height/2 + 'px',
      width: size + 'px',
      height: size + 'px',
      borderRadius: '50%',
      background: color || '#FF6B35',
      pointerEvents: 'none',
      zIndex: '99999',
    });
    document.body.appendChild(p);
    p.animate([
      { transform: 'translate(0,0) scale(1)', opacity: 1 },
      { transform: `translate(${Math.cos(angle)*velocity}px, ${Math.sin(angle)*velocity}px) scale(0)`, opacity: 0 }
    ], { duration: 500 + Math.random()*300, easing: 'ease-out', fill: 'forwards' });
    setTimeout(() => p.remove(), 900);
  }
}
